

























































































































// Composition
import { defineComponent, ref, useRouter } from '@nuxtjs/composition-api'
import { storeToRefs } from 'pinia'

// Lodash
import isEmpty from 'lodash/fp/isEmpty'

// Store
import { useSearchStore } from '@/store/search'

// Composables
import useSearch from '@/composables/search/useSearch'
import useSearchUrl from '@/composables/search/useSearchUrl'
import useAppSearch from '@/composables/search/useAppSearch'
import useFacets from '@/composables/search/useFacets'

// Common
import { decodeHTMLEntities } from '@/common/utils/characters'

// Components
import PrimaryAntibodies from '@/assets/images/products/primary-antibodies.svg?inline'
import SecondaryAntibodies from '@/assets/images/products/secondary-antibodies.svg?inline'
import AntibodyConjugates from '@/assets/images/products/antibody-conjugates.svg?inline'
import ElisaKits from '@/assets/images/products/elisa-kits.svg?inline'
import Services from '@/assets/images/products/services.svg?inline'

export default defineComponent({
  components: {
    PrimaryAntibodies,
    SecondaryAntibodies,
    AntibodyConjugates,
    ElisaKits,
    Services,
  },

  setup() {
    const { addFacet } = useFacets()
    const searchStore = useSearchStore()
    const { getResults: results, ui, isProductTab, searchInput, searchSuggestions } = storeToRefs(searchStore)
    const { storedSearchInput, setDefaultSearchSettings, typeaheadGetAll } = useSearch()
    const { getSearchUrl } = useSearchUrl()
    const appSearch = useAppSearch()
    const router = useRouter()

    // Local var
    // const mostUsedQueries = ref()
    // const loadingMostUsedQueries = ref(false)
    // const newestProducts = ref()
    // const loadingNewestProducts = ref(false)
    const suggestions = ref(['Akt', 'Phospho-Akt'])
    const contactAddressesLeft = [
      {
        country: 'United States',
        tel: '877.678.8324',
        tollfree: true,
        email: 'support@cellsignal.com',
      },
      {
        country: 'Austria',
        tel: '+43 (0)720 880 536',
        email: 'eusupport@cellsignal.com',
      },
      {
        country: 'Belgium',
        tel: '0800 71640',
        tollfree: true,
        email: 'eusupport@cellsignal.com',
      },
      {
        country: 'Germany',
        tel: '+49 (0)69 9675 9070',
        email: 'eusupport@cellsignal.com',
      },
      {
        country: 'Netherlands & Rest of Europe',
        tel: '+31 (0)71 7200 200',
        email: 'eusupport@cellsignal.com',
      },
    ]
    const contactAddressesRight = [
      {
        country: 'United Kingdom',
        tel: '+44 1223 93 1164',
        email: 'eusupport@cellsignal.com',
      },
      {
        country: 'China',
        tel: '4006-473287',
        tollfree: true,
        email: 'tech@cellsignal.cn',
      },
      {
        country: 'Japan',
        tel: '+81-3-3295-1632',
        tollfree: true,
        email: 'techjp@cellsignal.com',
      },
      {
        country: 'Rest of World',
        tel: '877.678.8324',
        tollfree: true,
        email: 'support@cellsignal.com',
      },
    ]
    const productCategories = [
      {
        name: 'Primary Antibodies',
        component: 'PrimaryAntibodies',
      },
      {
        name: 'Secondary Antibodies',
        component: 'SecondaryAntibodies',
      },
      {
        name: 'Antibody Conjugates',
        component: 'AntibodyConjugates',
      },
      {
        name: 'ELISA Kits',
        component: 'ElisaKits',
      },
      {
        name: 'Services',
        component: 'Services',
      },
    ]

    // get query suggestions and only use the first 4 characters from the search string
    // Otherwise, we never get suggestions
    const getQuerySuggestions = async () => {
      const fields = isProductTab.value ? ['namenotags', 'description'] : ['title']

      const options = {
        query: searchStore.searchInput.slice(0, 3),
        size: 3,
        types: {
          documents: {
            fields,
          },
        },
      }

      try {
        const response = await fetch(appSearch.getElasticQuerySuggestionsEndpoint(searchStore.tabs.selectedTab), {
          method: 'POST',
          body: JSON.stringify(options),
          headers: appSearch.getAxiosHeaders(),
        })

        const json = await response.json()
        searchStore.setSearchSuggestions(json)
        //
      } catch (error: any) {
        console.error(error)
      }
    }

    // perform Elasticsearch query

    if (!isEmpty(searchInput.value)) {
      // getMosedUsedQueries()
      // getNewestProducts()
      getQuerySuggestions()
    }

    // On click on a most used phrase term
    const searchMostUsedPhrase = (term: string) => {
      // changes in store
      searchStore.setSearchInput(term)
      searchStore.hideSuggests()

      // back to default
      setDefaultSearchSettings(true)

      // perform request
      router.push(getSearchUrl({ nr: 1 }))

      // exceute a suggestion search under the hood
      typeaheadGetAll()
    }

    // On click on a search suggestion
    const searchSuggestion = (term: string) => {
      // changes in store
      searchStore.setSearchInput(term)
      storedSearchInput.value = term

      // send request
      router.push(getSearchUrl({ redirect: false }))

      // exceute a suggestion search under the hood
      typeaheadGetAll()
    }

    // Delete object with results on onMount
    // onUnmounted(() => {
    //   mostUsedQueries.value = null
    //   newestProducts.value = null
    // })

    const onProductCategoryClick = (name: string) => {
      // delete current searchterm
      searchStore.setSearchInput('')
      storedSearchInput.value = ''

      // back to default
      setDefaultSearchSettings(true)

      // redirect to another page
      if (name === 'Services') {
        router.push('/services')
        return
      }

      // add the product category facet
      addFacet('categories', name)

      // perform a new search
      router.push(getSearchUrl())
    }

    const suggestionHTML = (suggestion: string, index: number) => {
      if (searchSuggestions?.value === undefined) return

      if (index < searchSuggestions.value.results.documents.length - 1) {
        return decodeHTMLEntities(suggestion + '<span>,</span>')
      } else {
        return decodeHTMLEntities(suggestion)
      }
    }

    return {
      results,
      ui,
      searchInput,
      // mostUsedQueries,
      // newestProducts,
      // loadingMostUsedQueries,
      // loadingNewestProducts,
      decodeHTMLEntities,
      searchMostUsedPhrase,
      suggestions,
      contactAddressesLeft,
      contactAddressesRight,
      productCategories,
      onProductCategoryClick,
      searchSuggestions,
      searchSuggestion,
      suggestionHTML,
      searchStore,
      isEmpty,
      storedSearchInput,
    }
  },
})
